import CareMapprButton from '../../../../components/Button/CareMapprButton';
import CaremapprModal from '../../../../components/Modal/CaremapprModal/CaremapprModal';
import type { PatientConfirmationDetails } from '../../lib/types';
import { formatAppointmentDateTime } from '../../../../helpers/dateHelper';

interface PatientConfirmationProps {
  show: boolean;
  details: PatientConfirmationDetails | null;
  onCancel: () => void;
  onConfirm: () => void;
  onClose: () => void;
}

const PatientConfirmation = ({
  show,
  details,
  onCancel,
  onConfirm,
  onClose,
}: PatientConfirmationProps) => {
  if (!details) {
    return null;
  }

  return (
    <CaremapprModal
      id="chat-patient-modal"
      show={show}
      onHide={onClose}
      bodyClassName="p-0"
      body={
        <div className="d-flex h-100 flex-column justify-content-between p-4">
          <div>
            <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
              <h2 className="chat-modal-title mb-0">
                Is this the correct patient?
              </h2>
              <button
                type="button"
                aria-label="Close patient confirmation modal"
                onClick={onClose}
                className="btn-close chat-modal-close shadow-none"
              />
            </div>
            <p className="chat-modal-copy mb-0">
              The consult ID you entered is for a patient seeing{' '}
              <strong>{details.appointmentDoctorName}</strong> from{' '}
              <strong>{details.appointmentGpPractice}</strong> at{' '}
              <strong>
                {formatAppointmentDateTime(
                  details.appointmentDate,
                  details.appointmentTime,
                )}
              </strong>
              . Is this correct?
            </p>
          </div>
          <div className="d-flex gap-3 mt-4">
            <CareMapprButton
              type="button"
              variant="secondary"
              label="No"
              onClick={onCancel}
              extraClassNames="w-100 my-0"
            />
            <CareMapprButton
              type="button"
              label="Yes"
              onClick={onConfirm}
              extraClassNames="w-100 my-0"
            />
          </div>
        </div>
      }
    />
  );
};

export default PatientConfirmation;
